'use client';

import { useEffect, useState } from 'react';
import { useNavigation } from './navigation-context';

export function ProgressBar() {
  const { loadingHref, navKey, } = useNavigation();
  const [phase, setPhase,] = useState<`idle` | `running` | `finishing`>(`idle`);

  useEffect(() => {
    if (loadingHref) {
      setPhase(`running`);
    }
  }, [navKey,]); // navKey increments on every navigate, even re-clicks

  useEffect(() => {
    if (loadingHref !== null) return;
    if (phase !== `running`) return;
    setPhase(`finishing`);
    const t = setTimeout(() => setPhase(`idle`), 600);
    return () => clearTimeout(t);
  }, [loadingHref,]);

  if (phase === `idle`) return null;

  return (
    <div
      key={navKey}
      className={`progress-bar progress-bar--${phase}`}
    />
  );
}
